export default __webpack_public_path__ + "static/media/Analytic.bcf1296d.svg";